'use strict';

angular.module('atex.dam').directive('damOriginalContent', ['ContentService', '$state',
  function (ContentService, $state) {
    return {
      restrict: 'EA',
      templateUrl: 'views/dam-original-content.html',
      replace: false,
      scope: {
        aspect: "="
      },

      link: function (scope) {

        var engage = scope.aspect.data;
        scope.entry = {};

        scope.entry.timestamp = engage.timestamp;
        scope.entry.application = engage.application;
        scope.entry.contentId = engage.contentId;
        scope.entry.userName = engage.userName;
        scope.entry.type = engage.type;
        scope.entry.name = engage.name;

        scope.open = function () {
          ContentService.getContent({id: scope.entry.contentId}).then(function (entry) {
            atex.dam.AngularUtils.fixUrls(entry.data);
            entry._data = entry.data;
            entry.duplicationInfo=scope.entry;
            $state.go('list.contents', {'items': [entry]});
            //$state.go('list.edit', { ids : entry });
          });
        };
      }
    };
  }]);
